import React, { useState } from "react";
import Slider from "react-slick";
import { Card, Collapse } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import logo from "../../assets/landingFeatures/qhrFlow.png";
import Footer from "../footer";
import { Button, Empty } from "antd";
import vendor from "../../assets/landingFeatures/vendorconnect.png";
import { MenuOutlined } from "@ant-design/icons";

import LandingHeader from "../header";
import "./qhrflowvendorconnect.scss";

function QHRFVendorConnect(props) {
  const [loader, SetLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [hamburgerMenuOpen, setHamburgerMenuOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { handleSubmit } = props;
  const { Meta } = Card;

  const text_org = `
  Efficient Team, Improved Productivity, Save Cost, Increased Revenue.
  `;
  const text_managers = `
    Assign tasks, Monitor Performance of Team and Vendors, Multiple Analytics
  `;
  const text_recruiters = `
      Organize data, simplified End to End Sourcing`;
  const text_candidates = `
    Knows each steps of his Job Application and outputs
`;
  const text_interviewers = ` Get the filtered Quality candidates and View Interview Schedules`;
  const text_vendors = `
      Clean vendor Admin panel to see Application progress
`;
  const items_features = [
    {
      key: "1",
      label: "Be Part of Clients Vision",
      children: <p>{text_org}</p>,
    },
    {
      key: "2",
      label: "Synched Data",
      children: <p>{text_managers}</p>,
    },
    {
      key: "3",
      label: "Email Notifications",
      children: <p>{text_recruiters}</p>,
    },
  ];

  const items = [
    {
      key: "1",
      label: "Current JDs Database",
      children: <p>{text_org}</p>,
    },
    {
      key: "2",
      label: "Your Resumes",
      children: <p>{text_managers}</p>,
    },
    {
      key: "3",
      label: "View Status and Analytics",
      children: <p>{text_recruiters}</p>,
    },
  ];
  const contentStyleQhrFlow = {
    margin: 20,
    padding: "5px",
    height: "300px",
    width: "auto",
    background: "#d0ece7 ",
  };

  const settings = {
    dots: false,
    speed: 10000,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 10,
  };

  const onChange = (key) => {
    console.log(key);
  };

  const handleSignin = () => {
    navigate("/login");
  };

  const handleSignup = () => {
    navigate("/signup");
  };
  //
  const handleOnclick = (e) => {
    navigate("/qhrflow");
  };
  return (
    <div className="qhrflow-vendorconnect-wrapper">
      <LandingHeader />

      <div className="qhrflow-vendorconnect-header">
        <div className="qhrflow-vendorconnect-header-left">
          <div className="qhrflow-vendorconnect-logo">
            <img
              className="qhrflow-vendorconnect-logo-img"
              src={logo}
              onClick={() => handleOnclick()}
            />
          </div>
        </div>
        
        <div className="qhrflow-vendorconnect-header-right">
          <nav className="qhrflow-vendorconnect-menu">
            <Link to="/qhrflow">Features</Link>

            <Link to="/qhrflowvendorconnect">
              VendorConnect
            </Link>
          </nav>
          <div className="qhrflow-vendorconnect-sign">
            <Button
              className="qhrflow-vendorconnect-sign-button"
              onClick={() => handleSignin()}
            >
              VendorConnect Sign In
            </Button>
          </div>
        </div>
        <div
          className="qhrflow-vendorconnect-hamburger-menu"
          onClick={() => setHamburgerMenuOpen(!hamburgerMenuOpen)}
        >
          <MenuOutlined />
        </div>
      </div>

      <div
        className={`qhrflow-vendorconnect-header-responsive ${
          hamburgerMenuOpen ? "open" : ""
        }`}
      >
        <div
          className="qhrflow-vendorconnect-header-responsive-item"
          onClick={() => navigate("/qhrflowvendorconnect")}
        >
          QHRFLOW VendorConnect
        </div>
        <hr className="qhrflow-vendorconnect-header-responsive-hr" />

        <div
          className="qhrflow-vendorconnect-header-responsive-item"
          onClick={() => navigate("/signup")}
        >
          VendorConnect Sign In
        </div>
      </div>

      <div className="qhrflow-vendorconnect-main">
        <div className="qhrflow-vendorconnect-main-text">
          Vendor WorkFlow
        </div>
        <div className="qhrflow-vendorconnect-main-slider">
          <div className="punch-heading-wrapper">
            <div>
              <img src={vendor} alt="hiring" width="120" height="120" />
            </div>
          </div>
          <div className="qhrflow-vendorconnect-selectable-wrapper">
            <Collapse
              items={items_features}
              defaultActiveKey={["1"]}
              onChange={onChange}
            />
          </div>
        </div>
      </div>

      <div className="landing-features features-wrapper">
        <div className="feature-heading">Coming Soon </div>
      </div>

      {/* Footer */}
      <div className="landing-footer">
        <Footer />
      </div>
    </div>
  );
}

export default QHRFVendorConnect;
